import { createContext } from "react";

export const RequestContext = createContext({
  requestData: null,
  requestGroup: null,
  getRequests: () => {},
});
